/* eslint-disable import/prefer-default-export */
// Converts numbers 0 - 9 to 00 - 09
export const padDigit = (d) =>
  d < 10 && d > -1 ? `0${d.toString()}`.slice(-2) : d.toString();

export const encodeParams = (data) =>
  Object.keys(data)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');

// returns a string with the first letter capitalized
export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// returns a string with the first letter lowercase
// the rest of the string retains its case
export const uncapitalize = (s) => s.charAt(0).toLowerCase() + s.slice(1);
